import { render, staticRenderFns } from "./NewRegistration.vue?vue&type=template&id=d46a4876&"
import script from "./NewRegistration.vue?vue&type=script&lang=js&"
export * from "./NewRegistration.vue?vue&type=script&lang=js&"
import style0 from "./NewRegistration.vue?vue&type=style&index=0&id=d46a4876&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports